module.exports = __webpack_public_path__ + "static/media/defaultCoin.05aee838.svg";